import type { RouteRecordRaw } from "vue-router";

export const rootRoutes: RouteRecordRaw[] = [
  {
    path: "/",
    name: "home",
    component: () => import("../pages/index.vue"),
    meta: {
      requiresAuth: true,
    },
  },
  // Note: /gallery/how_to is defined in gallery/routes.ts
  // Note: /join with children is defined in join/routes.ts
  {
    path: "/go",
    name: "go-login",
    component: () => import("../pages/go.vue"),
  },
  {
    path: "/login",
    name: "login",
    component: () => import("../pages/login.vue"),
  },
  {
    path: "/tools",
    name: "tools",
    component: () => import("../pages/tools.vue"),
  },
  {
    path: "/pricing",
    name: "pricing",
    component: () => import("../pages/pricing.vue"),
  },
  {
    path: "/users/continue_sign_in",
    name: "continue-sign-in",
    component: () => import("../pages/continue-sign-in.vue"),
  },
  {
    // Rendered when ErrorsController serves the SPA for a 403/404/422. Not
    // reached by normal navigation — MainEntryPointApp routes here on boot
    // based on the server-provided error status. No auth requirement so
    // logged-out shared-link recipients can see it.
    path: "/error/:status",
    name: "error",
    component: () => import("../pages/error.vue"),
  },
];
